<div class="container-fluid" style="padding: 0px">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a routerLink="/corporate//marketing-tool">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a routerLink="/corporate/cb-email-templates">Email Templates</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Email Template Builder
      </li>
    </ol>
  </nav>
</div>
<div class="email-builder-commpand-panel">
  <form
    [formGroup]="templateForm"
    (ngSubmit)="submit()"
    class="template-builder-form w-100"
  >
    <div class="add-template-row">
      <!-- Select Company Dropdown -->
      <div class="form-group">
        <label for="exampleForm2"
          >Select Company Name<span style="color: red">*</span></label
        >
        <select
          formControlName="company"
          class="form-control formstyle"
          [attr.disabled]="editTemplateId ? 'disabled' : null"
          [ngClass]="
            submitted && templateForm.get('company')?.errors
              ? 'error-border'
              : ''
          "
        >
          <option value="">Select Company Name</option>
          <option
            *ngFor="let userObj of getCompanyobj"
            [value]="userObj.customer_id"
          >
            {{ userObj.customer_company_name }}
          </option>
        </select>
      </div>

      <!-- Select Domain Dropdown -->
      <div class="form-group" *ngIf="!editTemplateId">
        <label for="domainName">Select Domain </label>
        <select
          id="domainName"
          formControlName="domainName"
          class="form-control formstyle"
          [attr.disabled]="templateForm.get('company')?.value === '' ? 'disabled' : null"
          [ngClass]="
            submitted && templateForm.get('domainName')?.errors
              ? 'error-border'
              : ''
          "
        >
          <option value="" disabled>Select Domain</option>
          <option *ngFor="let domainObj of domainData" [value]="domainObj.id">
            {{ domainObj.domain_name }}
          </option>
        </select>
      </div>
      
      <!-- Select Journey Dropdown -->
      <div class="form-group">
        <label for="journeyType">Select Journey </label>
        <select
          id="journeyType"
          formControlName="journeyType"
          class="form-control formstyle"
          [attr.disabled]="
            templateForm.get('company')?.value === '' ? 'disabled' : null
          "
          [ngClass]="
            submitted && templateForm.get('journeyType')?.errors
              ? 'error-border'
              : ''
          "
        >
          <option value="" disabled>Select Journey</option>
          <option
            *ngFor="let userObj of journeyTypeObj"
            [value]="userObj.journey_id"
          >
            {{ userObj.journey_name }}
          </option>
        </select>
      </div>

      <!-- Select Theme Dropdown -->
      <div class="form-group" #themeDropdown>
        <label>Select Theme</label>
        <div class="dropdown w-100">
          <button
            class="dropdown-toggle w-100 text-start form-control d-flex align-items-center justify-content-between"
            style="min-width: 150px; overflow: hidden;"
            [attr.disabled]="
              templateForm.get('journeyType')?.value === '' ? 'disabled' : null
            "
            [class.theme-drop-active]="isThemeDropActive"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            (click)="toggleDropdown($event)"
          >
            {{ selectedThemeItem ? selectedThemeItem : "Select Option" }}
          </button>

          <ul
            [class.theme-drop-active]="isThemeDropActive"
            class="theme-items dropdown-menu w-100 p-2"
          >
            <!-- Search input (standalone ngModel) -->
            <li class="theme-search-li mb-2">
              <input
                type="text"
                class="form-control"
                placeholder="Search..."
                [(ngModel)]="searchText"
                [ngModelOptions]="{ standalone: true }"
                (input)="onSearchChange()"
              />
              <button
                ngbTooltip="Add New Theme"
                placement="left"
                tooltipClass="club-custom-tooltip"
                type="button"
                (click)="OpenAddThemeModal(addNewTheme)"
                class="btn"
              >
                <i class="bi bi-plus"></i>
              </button>
            </li>

            <!-- Options -->
            <li *ngFor="let item of filteredThemeItems">
              <button
                class="dropdown-item mb-1"
                [ngClass]="
                  templateForm.get('themeId').value.includes(item.theme_id)
                    ? 'selected-theme'
                    : ''
                "
                type="button"
                (click)="selectThemeItem(item, 'dropdownClick')"
              >
                {{ item.theme_name }}
              </button>
            </li>

            <!-- No result -->
            <li *ngIf="filteredThemeItems.length === 0">
              <span class="dropdown-item text-muted">No results found</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Select Template Dropdown -->
      <div class="form-group position-relative">
        <label for="templateName"
          >Template Name<span style="color: red">*</span></label
        >
        <input
          type="text"
          class="form-control"
          id="templateName"
          formControlName="templateName"
          placeholder="Enter template name"
          [class.error-border]="
            submitted && templateForm.get('templateName')?.invalid
          "
        />
      </div>

      <!-- Select Subject Dropdown -->
      <div class="form-group">
        <label for="templateSubject"
          >Subject<span style="color: red">*</span></label
        >
        <div class="dropdown w-100">
          <input
            type="text"
            class="form-control"
            id="templateSubject"
            formControlName="templateSubject"
            placeholder="Enter email subject"
          />
        </div>
      </div>

      <!-- Select Preview Dropdown -->
      <div class="form-group" #previewField>
        <label>Preview image<span class="req">*</span></label>

        <div class="dropdown w-100">
          <button
            type="button"
            class="preview-trigger"
            [class.theme-drop-active]="popoverOpen"
            (click)="togglePreviewPopover($event)"
          >
            <img *ngIf="activePreviewUrl" [src]="activePreviewUrl" alt="Preview" class="trigger-thumb" />
            <i
              *ngIf="!activePreviewUrl"
              class="fa trigger-icon"
              [ngClass]="{
                'fa-paint-brush': previewSource === 'theme',
                'fa-upload': previewSource === 'upload',
                'fa-magic': previewSource === 'generate'
              }"
            ></i>
            <span class="trigger-text">{{ previewSourceLabel  }}</span>
            <i class="fa fa-chevron-down trigger-caret" [class.rotate]="popoverOpen"></i>
          </button>

          <ul [class.theme-drop-active]="popoverOpen" class="preview-popover p-2">
            <li>
              <button type="button" class="popover-item" [class.active]="previewSource === 'theme'" (click)="setPreviewSource('theme')">
                <i class="fa fa-paint-brush"></i>
                <span>Use theme image</span>
                <i *ngIf="previewSource === 'theme'" class="fa fa-check check-icon"></i>
              </button>
            </li>

            <li>
              <button type="button" class="popover-item" [class.active]="previewSource === 'upload'" (click)="setPreviewSource('upload')">
                <i class="fa fa-upload"></i>
                <span>Upload custom</span>
                <i *ngIf="previewSource === 'upload'" class="fa fa-check check-icon"></i>
              </button>

              <div class="upload-row" *ngIf="previewSource === 'upload'">
                <label class="upload-link">
                  {{ selectedFileName ? 'Replace' : 'Choose file' }}
                  <input type="file" accept="image/*" (change)="onFileSelected($event)" hidden />
                </label>
                <span class="upload-filename" *ngIf="selectedFileName">{{ selectedFileName }}</span>
                <i *ngIf="selectedFileName" class="fa fa-trash remove-icon" (click)="removeFile()"></i>
              </div>
            </li>

            <li>
              <button type="button" class="popover-item" [class.active]="previewSource === 'generate'" (click)="setPreviewSource('generate')">
                <i class="fa fa-magic"></i>
                <span>Generate from template</span>
                <i *ngIf="previewSource === 'generate'" class="fa fa-check check-icon"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Buttons -->
      <div
        class="form-group btn-form-group d-flex align-items-end"
        style="padding-bottom: 4px; justify-content: space-between; max-width: fit-content;"
      >
        <button
          class="custbtn savebtn"
          type="submit"
          [disabled]="templateForm.invalid"
        >
          {{ editTemplateId ? "Update" : "Save" }}
        </button>
        <button
          type="button"
          (click)="goBackToTemplateList()"
          class="custbtn-outline"
        >
          Back
        </button>
      </div>
      <div
        class="error maxlength-error"
        *ngIf="templateForm.get('templateName')?.errors?.maxlength"
      >
        Template Name cannot exceed 100 characters.
      </div>
    </div>
  </form>
</div>

<div class="grapesjs-container" #editorWrapper>
  <!-- Editor Container -->
  <div class="gjs-editor"></div>
</div>

<ng-template #addNewTheme let-modal>
  <div class="scroller">
    <div class="wholePop filtMain">
      <div class="modal-header dialHead w-100">
        <h4 class="modal-title mb-0 float-left">Add Theme</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="
            modal.dismiss('Cross click');
            imageChangedEvent = null;
            croppedImage = null
          "
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="clearfix"></div>
      </div>
      <div class="modal-body">
        <app-theme-form
          [isComponentLoad]="false"
          (OnThemeAdd)="onModalThemeAdd()"
        ></app-theme-form>
      </div>
    </div>
  </div>
</ng-template>
